module.exports = __webpack_public_path__ + "static/landing_page_background_wide-d8260478ee467c278f9d71e8f9cec6f8.png";